import React, { useState } from 'react'
import DocumentTitle from '../../../components/DocumentTitle/DocumentTitle'
import ApcStepper from '../../../components/APC/StepperAPC/ApcStepper';
import { nouvelleStepsAPC } from '../../../utils/texts';
import StepOne from '../../../components/APC/Attestation/Steps/StepOne';
import StepTwo from '../../../components/APC/Attestation/Steps/StepTwo';
import StepThree from '../../../components/APC/Attestation/Steps/StepThree';

const Nouvelle = () => {
  const [ activeStep,setActiveStep ] = useState(1); 
  const [ isFind,setIsFind ] = useState(false);
  const [ paiement,setPaiement ] = useState({
    reference: "",
       demandeur:{
        fullName:'',
        adresse: '',
        telephone:'',
        email: '',
        nina:'',
        denominationSociete:'',
        rccm: '',
        typeDemandeur: '',
       },
       infovehicule:{ 
        marque: '',
        modele: '',
        numeroChassis:[],
        categorie: '',  
        ptac: 0,
        dateMiseCirculation:'',
        paysProvenance:'',
        paysDestination:'',
        dossier:[] ,
        poidsTotalRoulant:0,
        poidsAVide:0,
        puissanceFiscale:0,
        chargeUtile:0,
        couleur:'',
        otherColor:""
       }
  });
  const nextStep = () => {
    if( activeStep <= 4 )
      setActiveStep((s) => s + 1)
  }  
  const prevStep = () => {
    if( activeStep >= 1 ){
        setActiveStep((s) => s - 1);
    }
  }  
  const handleInput = (e) => {

    const { name, value } = e.target;
    setPaiement({
      ...paiement,
      [name]: value
    });
    setIsFind(false);
  }
  const stepPage = () => {
    switch( activeStep ){
        case 1: 
           return <StepOne
                    setActiveStep={setActiveStep }
                    activeStep={ activeStep }
                    nextStep={nextStep}
                    paiement={paiement}
                    setPaiement={setPaiement}
                    handleInput={handleInput}
                    isFind={isFind}
                    setIsFind={setIsFind}
                 />;
        case 2: 
           return <StepTwo
                    setActiveStep={setActiveStep }
                    activeStep={ activeStep }
                    nextStep={nextStep}
                    prevStep={prevStep}
                    paiement={paiement}
                    setPaiement={setPaiement}
                   />   
       case 3:    
           return <StepThree
                    setActiveStep={setActiveStep }
                    activeStep={ activeStep }
                    nextStep={nextStep}
                    prevStep={prevStep}
                    paiement={paiement}
                    setPaiement={setPaiement}
                 />                  
    }
}

  return (
    <div className='payment page'>
     <DocumentTitle title="Paiement Attestation d'enregistrement primaire" /> 
     <div className="header">
          <h3>Nouvelle Attestation d'enregistrement primaire"</h3>
          <p>Suivez les trois étapes suivantes pour faire un nouveau paiement.</p>
      </div>
      <div className="payment-zone">
         <div className="payment-steps">
           {/* <ApcStepper steps={paymentStepsAPC} activeStep={activeStep} /> */}
           <ApcStepper steps={nouvelleStepsAPC} activeStep={activeStep} />
         </div> 
         <div className="payment-form">
              { stepPage() }
         </div> 
      </div>    
  </div>
  )
}

export default Nouvelle;